<template>
  <div class="path-item" :class="{'active-path-item': path === activePath}" @click="select()">
    <div class="path-icon"></div>
    <div class="path-name">
      {{ path }}
    </div>
  </div>
</template>

<script>

export default {
  name: "PathItem",
  methods: {

    select() {
      this.$emit("handleSelectPath", {
        path: this.path
      })
    }

  },
  props: {
    path: {
      type: String,
      required: true,
    },

    activePath: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
#app {
  .path-item {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 16px;
    background: #fff;
    border-radius: 56px;
    margin: 5px 10px;
    cursor: pointer;
    border: 1px solid;
    opacity: 0.8;

    .path-name {
      text-transform: capitalize;
      font-size: 14px;
      line-height: 16px;
      letter-spacing: 0.03em;
      color: #000000;
    }

    &:hover, &.active-path-item {
      background: #26262c;
      opacity: 1;

      .path-name {
        color: #fff;
      }
    }
  }
}
</style>